import React, { useState } from 'react'
import { View, TextStyle } from 'react-native'
import { Dialog, DialogActions, DialogContent } from '@mui/material'
import { Button, RadioGroupWeb as RadioGroup, Text } from '@trivie/ui-mobile'
import { color } from '@trivie/ui-web/theme'
import { observer } from 'mobx-react-lite'
import {
  excelTypes,
  mediaTypes,
  pdfTypes,
  slideTypes,
  soundTypes,
  wordTypes,
} from '@trivie/core/src/utils/fileUtils'
import { FilterTermsProps } from '@trivie/core'

interface FilterLibraryModalProps {
  setFilterTerms: React.Dispatch<React.SetStateAction<FilterTermsProps>>
  filterTerms: FilterTermsProps
  isStatusFilter?: boolean
  open: boolean
  setShowModal: (item: boolean) => void
  title: string
}

const statusFilterOptions = [
  { label: 'Not Started', labelTx: 'Topic.notStarted', value: '1' },
  { label: 'In Progress', labelTx: 'Quiz.inProgress', value: '2' },
  { label: 'Completed', labelTx: 'Common.complete', value: '3' },
  { label: 'Locked', labelTx: 'Topic.locked', value: '4' },
]
const resourceTypeFilterOptions = [
  { label: 'Audio', labelTx: 'Audio', value: soundTypes },
  { label: 'Website', labelTx: 'Websites', value: 'url' },
  { label: 'Video', labelTx: 'Video', value: mediaTypes },
  {
    label: 'Document',
    labelTx: 'Document',
    value: excelTypes.concat(slideTypes, wordTypes),
  },
  { label: 'PDF', labelTx: 'PDF', value: pdfTypes },
]

export const FilterLibraryModal = observer((props: FilterLibraryModalProps) => {
  const {
    setFilterTerms,
    title,
    filterTerms,
    isStatusFilter = true,
    open = false,
    setShowModal,
  } = props

  const [filterTermItems, setFilterTermItems] = useState<FilterTermsProps>(filterTerms)

  return (
    <Dialog aria-labelledby="confirmation-dialog-title" open={open}>
      <DialogContent style={DIALOG_CONTENT}>
        <div style={BODY_TEXT_WRAPPER}>
          <View>
            <Text variant="titleEmphasized" style={SIGN_IN} text={title} />
            <View
              style={{
                flexDirection: 'row',
                justifyContent: 'space-between',
                width: '100%',
              }}
            >
              <RadioGroup
                multiple
                rowStyleOverride={{ marginHorizontal: 0 }}
                style={{ flex: 1 }}
                onPress={(value) => {
                  if (isStatusFilter) {
                    if (filterTermItems?.status?.includes(value)) {
                      const items = filterTermItems?.status?.filter((f) => f !== value)
                      setFilterTermItems({ ...filterTermItems, status: [...items] })
                    } else {
                      setFilterTermItems({
                        ...filterTermItems,
                        status: [...filterTermItems.status, value],
                      })
                    }
                  } else {
                    if (filterTermItems?.sources?.includes(value)) {
                      const items = filterTermItems?.sources?.filter((f) => f !== value)
                      setFilterTermItems({ ...filterTermItems, sources: [...items] })
                    } else {
                      setFilterTermItems({
                        ...filterTermItems,
                        sources: [...filterTermItems.sources, value],
                      })
                    }
                  }
                }}
                options={isStatusFilter ? statusFilterOptions : resourceTypeFilterOptions}
                value={isStatusFilter ? filterTermItems?.status : filterTermItems?.sources}
              />
            </View>
          </View>
        </div>
      </DialogContent>
      <DialogActions style={DIALOG_BUTTON_CONTAINER}>
        <Button
          accessibilityRole="button"
          accessibilityLabel="Confirm"
          style={{ borderRadius: 15, padding: 25, height: 36, backgroundColor: color.shade20 }}
          onPress={() => setShowModal(false)}
          tx="Common.close"
        />
        <Button
          accessibilityRole="button"
          accessibilityLabel="Confirm"
          style={{ borderRadius: 15, padding: 25, height: 36 }}
          onPress={() => {
            setFilterTerms(filterTermItems)
            setShowModal(false)
          }}
          tx="Update"
        />
      </DialogActions>
    </Dialog>
  )
})
const DIALOG_BUTTON_CONTAINER: React.CSSProperties = {
  display: 'flex',
  color: color.white,
  gap: 8,
}
const BODY_TEXT_WRAPPER: React.CSSProperties = {
  maxHeight: 500,
  paddingRight: 10,
  overflowY: 'auto',
  height: '100%',
  textAlign: 'left',
  fontSize: 15,
  letterSpacing: 0.3,
}
const DIALOG_CONTENT: React.CSSProperties = {
  paddingTop: 20,
  paddingLeft: 20,
  paddingRight: 20,
  maxWidth: 500,
  minWidth: 400,
  width: '100%',
}
const SIGN_IN: TextStyle = {
  fontWeight: '600',
  fontSize: 20,
  lineHeight: 28,
  textAlign: 'center',
  marginBottom: 12,
  width: '100%',
}
